import { useCallback, useEffect, useState } from 'react';
import useHttp from '../http/useHttp';
import { AssociationDetailsViewModel } from '../../Models/Association/association-details-viewmodels';

export default function useFetchAssociatonDetails(id: string): {
  associationsRecords: AssociationDetailsViewModel;
  isLoading: boolean;
  setAssociationHasUpdate?: (_: boolean) => void;
} {
  const { getDataResponse, getData } = useHttp();
  const [isLoading, setIsLoading] = useState(false);
  const [associationHasUpdate, setAssociationHasUpdate] = useState(false);

  const init = useCallback(
    async (entityId: string) => {
      if (!entityId) return;

      try {
        setIsLoading(true);
        await getData(`EntityRelationship?id=${entityId}`);
      } catch (error) {
        console.error('Failed to fetch association:', error);
      } finally {
        setIsLoading(false);
      }
    },
    [getData]
  );

  useEffect(() => {
    if (id) {
      void init(id);
    }
  }, [id, init]);

  useEffect(() => {
    if (associationHasUpdate && id) {
      void init(id);
      setAssociationHasUpdate(false);
    }
  }, [associationHasUpdate, id, init]);

  const associationsRecords: AssociationDetailsViewModel = getDataResponse?.data ?? [];

  return { associationsRecords, isLoading, setAssociationHasUpdate };
}
